import api from './api'

export const dashboardService = {
  getDashboard: async (company = '01', filters = {}) => {
    const response = await api.get('/dashboard/', {
      params: { company, ...filters },
    })
    return response.data
  },

  getCalendar: async (company = '01', year, month) => {
    const r = await api.get('/dashboard/calendar', {
      params: { company, year, month },
    })
    return r.data
  },

  // Yaklaşan + geciken hatırlatmalar (başlıktaki açılır pencere)
  getReminders: async (company = '01', params = {}) => {
    const r = await api.get('/dashboard/reminders', { params: { company, ...params } })
    return r.data
  },

  getCustomerAttention: async (company = '01', filters = {}) => {
    const r = await api.get('/dashboard/customer-attention', {
      params: { company, ...filters },
    })
    return r.data
  },

  getMyApprovals: async (company = '01', filters = {}) => {
    const r = await api.get('/dashboard/my-approvals', {
      params: { company, ...filters },
    })
    return r.data
  },

  getPendingDocuments: async (company = '01', filters = {}) => {
    const r = await api.get('/dashboard/pending-documents', {
      params: { company, ...filters },
    })
    return r.data
  },

  getDivisionProfit: async (company = '01', filters = {}) => {
    const r = await api.get('/dashboard/division-profit', {
      params: { company, ...filters },
    })
    return r.data
  },

  getKpis: async (company = '01', filters = {}) => {
    const response = await api.get('/dashboard/kpis', {
      params: { company, ...filters },
    })
    return response.data
  },

  getSummary: async (company = '01') => {
    const response = await api.get('/dashboard/summary', {
      params: { company },
    })
    return response.data
  },

  getRecentActivity: async (company = '01', limit = 10) => {
    const response = await api.get('/dashboard/activity', {
      params: { company, limit },
    })
    return response.data
  },

  getStockValue: async (company = '01') => {
    const response = await api.get('/dashboard/stock-value', {
      params: { company },
    })
    return response.data
  },

  getReservedValue: async (company = '01') => {
    const response = await api.get('/dashboard/reserved-value', {
      params: { company },
    })
    return response.data
  },
}
